/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_MINIMUM_AGE_REQUIREMENT',
              'FACILITY_MINIMUM_AGE_REQUIREMENTS_FOR_CERTAIN_TYPES_OF_WORKERS_',
              'AGE_VERIFICATION_PROCESS',
              'REMEDIATION_FOR_CHILD_LABOR_FOR_WHEN_CHILDREN_UNDER_THE_LEGAL_M',
              'CHILDREN_VISITING_FACILITY_PRODUCTION_AREAS_I_E_FOR_WHEN_THOSE_',
              'WORK_RESTRICTIONS_FOR_YOUNG_WORKERS',
              'WORK_RESTRICTIONS_FOR_APPRENTICES_INTERNS_TRAINEES',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_1: valueSchema,
  },
}
